import React from "react";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useEnvironment } from "../../Hooks";
import request from "../../Api/request";
import config from "../../Config";
import { format } from "date-fns";
import css from "./styles.styl";

export const EmployeeAvatarRenderer = ({ data }) => {
    const environment = useEnvironment();
    const domain = config.environments.find((env) => env.name === environment)?.cdn;

    return (
        <span className={css.avatarContainer}>
            {data && domain && (
                <img
                    alt={`${data.name} Logo`}
                    src={`${domain}/avatar/${data._id}/`}
                    className={css.avatarImage}
                />
            )}
            <p className={css.avatarName}>{data.name}</p>
        </span>
    );
};

export const RemoveEmployeeRenderer = ({ data }) => {
    const environment = useEnvironment();
    const queryClient = useQueryClient();

    const { mutate: removeSuperUser } = useMutation({
        mutationFn: () => request({
            url: `/${environment}/super-users/${data._id}`,
            method: "DELETE",
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["super-users", environment] });
        }
    });

    return (
        <div className={css.removeButtonContainer}>
            <button className={css.removeButton} type="button" onClick={() => removeSuperUser()}>
                Remove
            </button>
        </div>
    );
};

export const RemoveLoganUserRenderer = ({ data }) => {
    const queryClient = useQueryClient();

    const handleRemoveLoganUser = async () => {
        if (!window.confirm(`Are you sure you want to delete Logan user "${data.displayName || data.email}"?`)) {
            return;
        }

        try {
            await request({
                url: `/administration/users/${data._id}`,
                method: "DELETE",
            });

            queryClient.invalidateQueries({ queryKey: ["logan-users"] });
        } catch (error) {
            console.error("Error deleting Logan user:", error);
            alert("Failed to delete user. Please try again.");
        }
    };

    return (
        <div className={css.removeButtonContainer}>
            <button className={css.removeButton} type="button" onClick={handleRemoveLoganUser}>
                Remove
            </button>
        </div>
    );
};

export const LoganUserRenderer = ({ data }) => {
    return (
        <span className={css.userNameContainer}>
            <p className={css.userName}>
                {data?.displayName || data?.email}
            </p>
        </span>
    );
};

export const LoganUserRolesRenderer = ({ data }) => {
    return data?.roles && Array.isArray(data.roles) ? data.roles.join(", ") : "";
};

export const DateRenderer = ({ value }) => {
    return value ? format(new Date(value), "MM/dd/yyyy") : "";
};